export enum CloseButtonHierarchy {
   Tertiary = 'TERTIARY'
}

export enum CloseButtonSubVariant {
   Primary = 'PRIMARY',
   Gray = 'GRAY'
}
